exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".g_pop_share_spm[data-v-28f6adce]{position:fixed;z-index:11111;left:0;top:0;right:0;bottom:0;margin:auto;background-color:rgba(0,0,0,.8)}.g_pop_share_spm .pop_con[data-v-28f6adce]{position:absolute;right:0;top:.04267rem;text-align:center;width:100%}.g_pop_share_spm .pop_con img[data-v-28f6adce]{height:auto;width:76%}.__darkmode__ .g_pop_share_spm[data-v-28f6adce]{background-color:hsla(0,0%,100%,.08)}", ""]);

// exports
